// xtm.withacg.com — same Azure app registration as the CRM and
// internal.withacg.com (single tenant, "ACG Entra"). redirectUri is left
// dynamic (window.location.origin) so local dev works out of the box;
// once xtm.withacg.com is deployed, that origin must be added to the app
// registration's list of allowed redirect URIs in the Azure portal before
// SSO will complete there.

const XTM_CLIENT_ID = "56c99f31-7c06-46c0-be54-4b6b7c25e48a";
const TENANT_ID      = "202593ed-07f2-4fe1-b7ef-bce63d5c45c2";

export const msalConfig = {
  auth: {
    clientId:                 XTM_CLIENT_ID,
    authority:                `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri:              window.location.origin,
    postLogoutRedirectUri:    `${window.location.origin}/#/sign-in`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation:          "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker:   false,
    windowHashTimeout:   9000,
    iframeHashTimeout:   9000,
    loadFrameTimeout:    9000,
  },
};

export const loginRequest = {
  scopes:      ["User.Read"],
  redirectUri: window.location.origin,
};
